import React from 'react';
import { FullPageLoading } from '../components/loading/FullPageLoading';
import { Loader } from '../components/loading/Loader';
import { SpinnerIcon } from '../components/loading/SpinnerIcon';

export default {
  title: 'Loading',
  component: FullPageLoading,
  argTypes: {
    category: {
      control: {
        type: 'select',
        options: ['default', 'transparent'],
      },
    },
  },
};

const FullPageTemplate = (args) => <FullPageLoading {...args} />;
const LoaderTemplate = (args) => <Loader {...args} />;
const SpinnerTemplate = () => <SpinnerIcon />;

export const FullPage = FullPageTemplate.bind({});
FullPage.args = {};

export const DefaultLoader = LoaderTemplate.bind({});
DefaultLoader.args = {};

export const TransparentLoader = LoaderTemplate.bind({});
TransparentLoader.args = {
  category: 'transparent',
};

export const Spinner = SpinnerTemplate.bind({});
